import {useEffect} from "react";
import isEmpty from "is-empty";
import {useStoreMobx} from "@/shared/lib/mobx/useStoreMobx";
import {usePage} from "@inertiajs/react";

export default function useShowWheelOfFortune() {
    const {props} = usePage();
    const {mobileApp = false, config = {}} = props;
    const {modalStore = {}} = useStoreMobx();
    const {saleTypes = {}} = config;
    const {wheelOfFortune = {}} = saleTypes;

    useEffect(() => {
        /**
         * Проходим далее если:
         * 1. На сайт попадают не из приложений
         * 2. Дата не null
         * 3. Текущая дата меньше установленной
         * 4. Окно показывается в первые
         */
        if (mobileApp || wheelOfFortune.endDate === null || new Date() > new Date(wheelOfFortune.endDate) || !isEmpty(localStorage.getItem('wheelOfFortune'))) {
            return;
        }

        // Показываем окно с задержкой в 3 секунды
        setTimeout(() => {
            modalStore.openWheelOfFortuneModal();
        }, 3000)
    }, []);
}
